import React from 'react';
import {
  Text,
  TextAppearance,
  ButtonCustomLink,
  ButtonAppearance,
  buttonPaddingGenerator,
  TextColor,
  DisableFocusWrapper,
  Alert,
  Info,
} from '@vw-marketing/us-components';
import { Recall } from '../../../../typings/general';
import {
  RecallContainer,
  RecallStatusWrapper,
  RecallLabel,
  TitleWrapper,
  HeadlineItemWrapper,
  FindDealerWrapper,
} from './styled';

interface RecallItemProps {
  recall: Recall;
  label: string;
  serviceDescription?: string;
}

interface RecallItems {
  label?: string;
  description?: string;
  headline?: boolean;
}
const DescriptionItem = ({
  description,
  label,
  headline,
}: RecallItems): JSX.Element => {
  const appereance = headline
    ? { appearance: TextAppearance.headline0350 }
    : {
        appearance: TextAppearance.copy200,
        // style: {lineHeight: TextLineHeight.TextLineHeight24}
      };
  return (
    <>
      {label && (
        <Text appearance={TextAppearance.copy200} bold>
          {label}
        </Text>
      )}
      <Text {...appereance}>{description}</Text>
    </>
  );
};

const RecallItem = ({
  recall,
  label,
  serviceDescription,
}: RecallItemProps): JSX.Element => (
  <RecallContainer>
    <RecallStatusWrapper isImportant={recall.statusImportant}>
      <RecallLabel>
        <Text
          appearance={TextAppearance.copy200}
          color={TextColor.primary}
          bold
          // style={{color: TextColor.primary, fontWeight: TextWeight.bold}}
        >
          {label}
        </Text>
      </RecallLabel>
      {recall.statusImportant ? <Alert /> : <Info />} &nbsp;
      <Text
        appearance={TextAppearance.copy200}
        color={TextColor.inherit}
        bold
        // style={{fontWeight: TextWeight.bold, color: TextColor.inherit}}
      >
        {recall.status}
      </Text>
    </RecallStatusWrapper>
    <TitleWrapper>
      <Text appearance={TextAppearance.headline0350}>
        {recall.vwgoaActionTitle}
      </Text>
    </TitleWrapper>
    <HeadlineItemWrapper>
      <DescriptionItem
        label="VW Action Code"
        description={recall.mfrRecallNumber}
        headline
      />
    </HeadlineItemWrapper>
    {recall.nhtsaRecallNumber &&
      recall.nhtsaRecallNumber.toLocaleLowerCase() !== 'awaiting#' && (
        <HeadlineItemWrapper>
          <DescriptionItem
            label="NHTSA Recall Number"
            description={recall.nhtsaRecallNumber}
            headline
          />
        </HeadlineItemWrapper>
      )}
    {serviceDescription && (
      <>
        <DescriptionItem description={serviceDescription} />
        <br />
      </>
    )}
    <DescriptionItem label="Start date" description={recall.startDate} />
    <br />
    <DescriptionItem
      label="Description"
      description={recall.recallDescription}
    />
    <br />
    <DescriptionItem label="Remedy" description={recall.remedyDescription} />
    <FindDealerWrapper>
      <DisableFocusWrapper>
        <ButtonCustomLink
          appearance={ButtonAppearance.Primary}
          padding={buttonPaddingGenerator(0, 35, 35, 35)}
          href={'/app/dccsearch/vw-us/en'}
        >
          <Text
            appearance={TextAppearance.copy150}
            color={TextColor.inherit}
            // style={{color: TextColor.inherit}}
          >
            Find a Dealer
          </Text>
        </ButtonCustomLink>
      </DisableFocusWrapper>
    </FindDealerWrapper>
  </RecallContainer>
);

export default RecallItem;
